import { useCallback } from 'react'

import useCategory from 'components/GamesNavBar/hooks/useCategory'
import { Category } from 'containers/GamesBlock/types'

import useSelectedCategory from './useSelectedCategory'

export default function useCurrentCategory() {
  const { category: selectedCategory } = useCategory()

  const getCategory = useCallback(
    (categories: Category[]) => categories.find(({ slug }) => selectedCategory === slug),
    [selectedCategory],
  )

  return useSelectedCategory(getCategory)
}
